import React, { useEffect, useRef, useState } from "react";
import "./DialogBox.css";

const DialogBox = ({ isOpen, onClose, children }) => {
  const popupContentRef = useRef(null);
  const [focusableElements, setFocusableElements] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      // Reset scroll position to top when dialog box opens
      if (popupContentRef.current) {
        popupContentRef.current.scrollTop = 0;
      }
    }
  }, [isOpen]);

  const getFocusableElements = (container) => {
    return Array.from(
      container?.querySelectorAll(
        'a, button, textarea, input, select,td,th, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(
      (el) =>
        !el.hasAttribute("disabled") &&
        !el.getAttribute("aria-hidden") &&
        el.offsetParent !== null
    );
  };

  useEffect(() => {
    initialModalFocus();
    
  }, [children]);

  const initialModalFocus = () =>{
    const elements = getFocusableElements(popupContentRef?.current);

    const nonFocusableElements = popupContentRef?.current?.querySelectorAll("h2, h3, p,td,th");
    nonFocusableElements?.forEach((el) => el.setAttribute("tabIndex", "0"));

    setFocusableElements([...elements]);

    if (elements.length > 0) {
      elements[0]?.focus();

      document?.activeElement?.blur();

      setTimeout(()=>{
        focusableElements?.current?.focus()
      },50)

    }
  }

  const handleKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();

      const isShiftPressed = event.shiftKey;
      let nextIndex;

      if (isShiftPressed) {
        nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
      } else {
        nextIndex = currentIndex === focusableElements.length - 1 ? 0 : currentIndex + 1;
      }

      setCurrentIndex(nextIndex);
      focusableElements[nextIndex]?.focus();
    } else if (event.key === "Escape") {
      onClose();
    }
  };

  return (
    <div className={`norstella-cf-popup ${isOpen ? "norstella-cf-open" : ""}`} tabIndex="-1" aria-live="assertive" role="dialog" aria-modal="modal">
      <div ref={popupContentRef} className="norstella-cf-popup-content" onKeyDown={handleKeyDown}>
        <button className="norstella-cf-close-button" aria-label="Close dialog" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default DialogBox;
